module.exports = __webpack_public_path__ + "img/pro2.b2a737e4.png";